let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("fTFcV"), load("kFEyO"), load("gryT8"), load("hhss7"), load("gM13h")]).then(() => parcelRequire('1RPPn'));